import {create} from 'zustand'

export const useStore = create(set => ({
    contactOpen: false,
    openContact: () => set({contactOpen: true}),
    closeContact: () => set({contactOpen: false}),
    retailerOpen: false,
    openRetailer: () => set({retailerOpen: true}),
    closeRetailer: () => set({retailerOpen: false}),
}))